export const getTypedAddressAction = (liveSuggestions) =>
  liveSuggestions ? "geocode" : "suggestions";

export const shouldFetchSuggestionsOnSubmit = (liveSuggestions) =>
  getTypedAddressAction(liveSuggestions) === "suggestions";

export const shouldHideSuggestionsOnInput = (liveSuggestions) =>
  !liveSuggestions;

export const getEnterAction = ({ liveSuggestions, optionsOpen }) =>
  optionsOpen
    ? "select-option"
    : getTypedAddressAction(liveSuggestions);
